import '../sass/main.scss';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import htmx from 'htmx.org';
import { gsap } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { init_text_animation } from './animation';

import Glide from '@glidejs/glide'

import YTPlayer from 'yt-player';

window['Alpine'] = Alpine;
Alpine.plugin(collapse);

type QueryNode = Document | ShadowRoot | HTMLElement;

gsap.registerPlugin(ScrollTrigger);
const REDUCED_MOTION = window.matchMedia(`(prefers-reduced-motion)`).matches;

// Init YT Player
let yt_modal;

let init = (node: QueryNode = document) => {
	yt_modal = new YTPlayer('#yt-video-modal');
	init_text_animation(node);

	// Probably move this to another file when we are done
	if (document.querySelector('.glide_products')) {
		let glider = new Glide('.glide_products', {
			// default is 2xl Tailwind Breakpoint
			type: 'slider',
			perView: 4,
			breakpoints: {
				640: { // < sm
					perView: 1,
				},
				768: { // sm
					perView: 1,
				},
				1024: { // md
					perView: 2,
				},
				1280: { // lg
					perView: 3,
				},
				1536: { // xl
					perView: 3,
				},
			}
		});
		glider.mount();
	}

	if (document.querySelector('.glide_reviews')) {
		let review_glider = new Glide('.glide_reviews', {
			type: 'slider',
			perView: 1,
		})
		review_glider.mount();
	}

	if (document.querySelector('.glide_team')) {
		let team_glider = new Glide('.glide_team', {
			type: 'slider',
			perView: 4,
			breakpoints: {
				640: { // < sm
					perView: 1,
				},
				768: { // sm
					perView: 1,
				},
				1024: { // md
					perView: 2,
				},
				1280: { // lg
					perView: 3,
				},
				1536: { // xl
					perView: 3,
				},
			}
		})
		team_glider.mount();
	}

	if (document.querySelector('.glide_related-articles')) {
		let related_articles_glider = new Glide('.glide_related-articles', {
			type: 'slider',
			perView: 3,
			breakpoints: {
				640: { // < sm
					perView: 1,
				},
				768: { // sm
					perView: 1,
				},
				1024: { // md
					perView: 2,
				},
				1280: { // lg
					perView: 3,
				},
				1536: { // xl
					perView: 3,
				},
			}
		})
		related_articles_glider.mount();
	}
}

document.addEventListener('DOMContentLoaded', e => {
	// console.log('The DOM has loaded!', e);
	Alpine.start();
	init(document);
	// Show a Page Loading screen between page transitions
	let page_loader_cover = document.querySelector('.page-loader-cover');
	if (page_loader_cover) {
		document.body.addEventListener('htmx:beforeRequest', e => {
			let no_loader = (<CustomEvent>e).detail
				?.requestConfig?.elt?.getAttribute('data-hx-no-page-loader');
			if (no_loader === null) {
				page_loader_cover.classList.add('show');
			}
		});
		document.body.addEventListener('htmx:afterSettle', _e => {
			page_loader_cover.classList.remove('show');
			// Update reference to loader as it may have changed
			page_loader_cover = document.querySelector('.page-loader-cover');
		});
	}
	// WooCommerce forces it's own AJAX controls in the cart.
	// Update the header cart when the cart controls are used.
	const cart_url = document.querySelector('#header_woo_cart')
		?.getAttribute('href');
	jQuery(document.body).on('wc_cart_emptied updated_cart_totals', e => {
		if (cart_url) {
			htmx.ajax('get', cart_url, {
				target: '#header_woo_cart',
			})
				.then(v => console.log('js htmx success!', v))
				.catch(err => console.error('js htmx failed!', err));
		}
	});

	// When full variation has been selected, update URL query string to match
	jQuery('.variations_form').on('show_variation', (_e, v) => {
		let keys = Object.keys(v.attributes);
		let attribs = keys
			.map(x => `${x}=${v.attributes[x]}`)
			.join('&');
		window.history.replaceState(null, null, `?${attribs}`);
	});
	// Remove query string when variations form is cleared
	jQuery('.variations_form').on('reset_data', _e => {
		window.history.replaceState(null, null, `//${location.host}${location.pathname}`);
	});
});
document.addEventListener('alpine:init', () => {
	const header_nav = document.querySelector('header nav.header-nav');
	// console.log('AlpineJS Loaded!');
	// Add events to close mobile menu when a menu-item has been clicked
	// (closes for transition)
	// TODO: Move these into the Custom Walker
	header_nav?.querySelectorAll('.menu-item a').forEach(x => {
		x.setAttribute('x-on:click', 'set_on_event(false, "htmx:afterSwap")');
	});
	// Add AlpineJS attrs to open and close sub-menus in mobile menu
	header_nav?.querySelectorAll('.menu-item-has-children').forEach(x => {
		x.setAttribute('x-data', "{sub_open: false}");
		x.querySelector('.sub-menu-opener')
			?.setAttribute('x-on:click', 'sub_open = !sub_open');
		x.querySelector('a')
			?.setAttribute(':class', "sub_open ? 'sub-menu_open' : ''");
		x.querySelector('.sub-menu')
			?.setAttribute(':class', "sub_open ? 'sub-menu_open' : ''");
	});
	// Sub-menu opener controls
	Alpine.data('mobile_menu_state', (init_state = false) => ({
		open: init_state,
		toggle() {
			this.open = !this.open;
		},
		set(state: boolean) {
			this.open = state;
		},
		set_with_delay(state: boolean, delay: number) {
			setTimeout(() => this.open = state, delay);
		},
		set_on_event(state: boolean, event: string) {
			addEventListener(event, _e => this.open = state);
		}
	}));
	Alpine.data('resource_card', () => ({
		timeline: undefined,
		init() {
			if (!REDUCED_MOTION) {
				this.timeline = gsap.timeline({
					paused: true,
					defaults: {
						duration: 0.3,
						ease: 'power2.inOut',
					},
				}).add('start')
					.to(this.$refs.image, {opacity: 0.5}, 'start')
					.fromTo(this.$refs.button,
						{opacity: 0, duration: 0.1},
						{opacity: 1},
						'start'
					)
					.fromTo(
						this.$refs.content,
						{y: '2rem'},
						{y: '0rem'},
						'start'
					)
					.add('end');
			} else {
				this.timeline = gsap.timeline();
			}
		},
		triggers: {
			['@mouseenter']() {
				this.timeline.play();
			},
			['@mouseout']() {
				this.timeline.reverse();
			},
		},
	}));
	Alpine.data('post_card', () => ({
		timeline: undefined,
		init() {
			if (!REDUCED_MOTION) {
				this.timeline = gsap.timeline({
					paused: true,
					defaults: {
						duration: 0.3,
						ease: 'power2.inOut',
					},
				}).add('start')
					.to(this.$refs.image, {opacity: 0.5}, 'start')
					.add('end');
			} else {
				this.timeline = gsap.timeline();
			}
		},
		triggers: {
			['@mouseenter']() {
				this.timeline.play();
			},
			['@mouseout']() {
				this.timeline.reverse();
			},
		},
	}));
	Alpine.data('yt_modal_player', (vid_code) => ({
		triggers: {
			['@click']() {
				yt_modal.load(vid_code);
				this.$dispatch('open_video_modal');
			},
		}
	}));
	Alpine.data('yt_modal', () => ({
		video_modal_open: false,
		triggers: {
			['@stop_video_modal']() {
				yt_modal.stop();
			}
		}
	}));
	Alpine.data('body', () => ({
		video_modal_open: false,
		enquiry_modal_open: false,
		triggers: {
			['@stop_video_modal']() {
				yt_modal.stop();
			}
		}
	}));
});

document.addEventListener('htmx:afterSwap', (e) => {
	// We know this is a CustomEvent, so we can safely cast
	let swapped_target = (<CustomEvent>e).detail?.target;
	if (swapped_target) {
		init(swapped_target);
	}
})
